import { useState } from 'react';
import './team.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

const BIO_LENGTH_LIMIT = 300;

function TeamCard({ member }) {
  const [expanded, setExpanded] = useState(false);
  const isLong = member.bio.length > BIO_LENGTH_LIMIT;

  return (
    <article className="team-card hover-lift">
      <img
        src={member.image}
        alt={`${member.name} headshot`}
        className="team-photo"
      />
      <h2>{member.name}</h2>
      <h4>{member.title}</h4>
      <p className={`team-bio${isLong && !expanded ? ' clamped' : ''}`}>{member.bio}</p>
      {isLong && (
        <button
          type="button"
          className="read-more-btn"
          onClick={() => setExpanded((prev) => !prev)}
          aria-expanded={expanded}
        >
          {expanded ? 'Read less' : 'Read more'}
        </button>
      )}
      {member.contact && <p className="contact">{member.contact}</p>}
    </article>
  );
}

function MeetTheTeam() {
  const team = [
    {
      name: 'Alison O’Kelly',
      title: 'Director',
      bio: "Alison O'Kelly is the Director of AOK Communications. A graduate of DCU with a Bachelors of Business Studies specialising in Operations Management, she combines strategic business knowledge with expertise in digital marketing, leadership and public speaking. Her experience and client-focused approach helps businesses strengthen their brand, engage with their audience and achieve measurable growth.",
      contact: 'enquiries@aokmentoring.com | 087 383 1780',
      image: images.team.alison
    },
    {
      name: 'Leah Power',
      title: 'Digital Marketing Specialist',
      bio: 'Leah is studying PR and Media at SETU, supporting online campaigns and building brand engagement across social platforms.',
      contact: 'leah@aokmentoring.com',
      image: images.team.leah
    },
    {
      name: "Eoin O'Kelly",
      title: 'Software Engineer',
      bio: 'Eoin develops and maintains software for us and our clients. He is studying Immersive Software Engineering at the University of Limerick.',
      contact: 'eoin@aokmentoring.com',
      image: images.team.eoin
    },
    {
      name: 'Daniel Tyutyunkov',
      title: 'Software Engineer',
      bio: 'Daniel develops and maintains software for us and our clients. He is studying Immersive Software Engineering at the University of Limerick.',
      contact: 'daniel@aokmentoring.com',
      image: images.team.daniel
    }
  ];

  return (
    <div className="team-page">
      <Seo
        title="Meet the Team"
        description="Meet the AOK Communications team of speakers, mentors, and marketers."
      />
      <Header />

      <section className="team-grid stagger-children reveal page-content">
        {team.map(member => (
          <TeamCard key={member.name} member={member} />
        ))}
      </section>

      <Footer />
    </div>
  );
}

export default MeetTheTeam;
